import AppError from '../../../errors/AppError';
import ResponseError from '../../../errors/ResponseError';

export default class ItemNamesTakenInFolderError extends AppError {
	takenNames: string[];

	constructor( {
		message, cause, takenNames
	}: {
		message?: string, cause?: Error, takenNames: string[]
	} ) {
		super( { message, cause } );

		this.takenNames = takenNames;
	}

	static fromResponseError( error: ResponseError ) {
		return new this( {
			message: error.message,
			cause: error,
			takenNames: ( error.getMetaField( 'duplicate_names' ) as string[] ) || []
		} );
	}
}
